import React from 'react';
import PropTypes from 'prop-types';

import { Headline, BodyCopy } from '@xingternal/typography';

const LinkSubject = ({ label, text, button }) => (
  <>
    <Headline>{label}</Headline>
    <BodyCopy>{text}</BodyCopy>
    <a href={button.href}>{button.label}</a>
  </>
);

LinkSubject.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  button: PropTypes.shape({
    href: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
};

export default LinkSubject;
